mutation AbortJob($jobId: ID!) {
    abortJob(jobId: $jobId) {
        _id
        status
        message
    }
}
